import {GetUserInfoService, GetRatingDeliveryService, GetShopsBetweenDatesService, GetPhotoProfileService} from "../Infrastructure/User.service";

export async function GetUserInfoLogic(id) {
  return GetUserInfoService(id);
}

export async function GetRatingDelivery(id){
  return GetRatingDeliveryService(id);
}

export async function GetShopsLogic(data){
  return GetShopsBetweenDatesService(data);
}

export async function GetPhotoProfileLogic(urlPhoto){
  return GetPhotoProfileService(urlPhoto);
}